import { createUser, getUser, getUsers } from '@lib/api'
import { usersKeys } from '@lib/keys'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

export const useUsers = () => {
  return useQuery(usersKeys.all, () => getUsers())
}

export const useUser = (userId: number) => {
  return useQuery(usersKeys.get(userId), () => getUser(userId))
}

export const useCreateUser = () => {
  const queryClient = useQueryClient()

  return useMutation(createUser, {
    onSuccess: () => queryClient.invalidateQueries(usersKeys.all),
  })
}
